<style scoped lang="scss" type="text/scss">

</style>

<template>
    <card class="right-panel-container">
        <el-form :model="schoolInfo" :rules="rules" ref="form" label-width="90px" label-position="left">
            <block-divider>基本信息</block-divider>

            <el-form-item label="学校名称" prop="name">
                <el-input disabled v-model="schoolInfo.name"></el-input>
            </el-form-item>

            <el-form-item label="学校标签" prop="tags">
                <el-select v-model="schoolInfo.tags" disabled="" multiple placeholder="暂未开放" class="full-width">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <block-divider>地址信息</block-divider>

            <el-form-item label-width="150px" label="省市区" prop="region_id">
                <province-city-county-selector v-model="schoolInfo.region_id"></province-city-county-selector>
            </el-form-item>

            <el-form-item label-width="150px" label="详细地址" prop="detail">
                <el-input  v-model="schoolInfo.detail" placeholder="请输入街道、门牌号等详细地址"></el-input>
            </el-form-item>

            <block-divider>附加信息</block-divider>

            <el-form-item label-width="150px"  label="备赛场地面积" prop="laboratory_area">
                <el-input v-model="schoolInfo.laboratory_area" placeholder="请输入备赛场地面积"></el-input>
            </el-form-item>

            <el-form-item label-width="150px"  label="竞赛主管部门" prop="competition_department">
                <el-input v-model="schoolInfo.competition_department" placeholder="请输入竞赛主管部门"></el-input>
            </el-form-item>
            <el-form-item label-width="150px"  label="举办校内赛" prop="school_competitions">
                <el-radio-group v-model="schoolInfo.school_competitions">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item  label-width="150px"  label="每年参加人数" prop="participants_per_year">
                <el-input v-model.number="schoolInfo.participants_per_year" placeholder="请输入每年参加人数"></el-input>
            </el-form-item>

            <el-form-item label-width="150px"  label="开设竞赛相关课程" prop="offering_courses">
                <el-input v-model="schoolInfo.offering_courses" placeholder="请输入开设课程(多门课用、分割)"></el-input>
            </el-form-item>

            <el-form-item class="submit-buttons">
                <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
                <el-button @click="reset()">重置</el-button>
            </el-form-item>
        </el-form>
    </card>
</template>

<script>
import Card from '../../../../../components/card';
import BlockDivider from '../../../../../components/divider/block';
import ProvinceCityCountySelector from '../../../../sub-components/province-city-county-selector';
import _ from 'lodash';

export default {
    name: '',
    components: {
        Card,
        BlockDivider,
        ProvinceCityCountySelector
    },
    data () {
        return {
            requesting: false,
            schoolInfo: {
                tags: []
            },
            options: [],
            rules: {
                name: [
                    {required: true, message: '校名不能为空', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                ],
                region_id: [
                    {required: true, message: '请选择学校省市区信息', trigger: 'blur'}
                ],
                detail: [
                    {required: true, message: '学校详细地址不能为空', trigger: 'blur'},
                    {min: 1, max: 60, message: '长度不能超过 60 个字', trigger: 'blur'}
                ],
                laboratory_area: [
                    {required: true, message: '团队实验室面积不能为空', trigger: 'blur'},
                    {pattern:  /^(([^0][0-9]+|0)\.([0-9])$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]+)$)|^(([1-9]+)$)/, message: '团队实验室面积必须为数字值', trigger: 'blur'},
                ],
                competition_department: [
                    {required: true, message: '竞赛主管部门不能为空', trigger: 'blur'},
                    {min: 1, max: 60, message: '长度不能超过 60 个字', trigger: 'blur'}
                ],
                school_competitions: [
                    {required: true, message: '举办校内赛不能为空', trigger: 'blur'},
                ],
                participants_per_year: [
                    {required: true, message: '每年参加人数不能为空', trigger: 'blur'},
                    {type: 'number', message: '参加人数必须为数字值', trigger: 'blur'},
                ],
                offering_courses: [
                    {required: true, message: '开设课程不能为空', trigger: 'blur'},
                    {min: 1, max: 60, message: '长度不能超过 60 个字', trigger: 'blur'}
                ],
            }
        };
    },
    computed: {
        currentManagedSchoolInfo () {
            return this.$store.state.school.currentManagedSchoolInfo;
        },
        currentManagedSchoolId () {
            return this.$store.state.school.currentManagedSchoolId;
        }
    },
    watch: {
        currentManagedSchoolInfo (info) {
            this.$refs.form.clearValidate();
            this.schoolInfo = this.extract(info);
        }
    },
    methods: {
        extract (info) {
            return {
                name: _.get(info, 'name', null),
                region_id: _.get(info, 'address.region_id', null),
                detail: _.get(info, 'address.detail', null),

                laboratory_area: _.get(info, 'school_extend.laboratory_area', null),
                competition_department: _.get(info, 'school_extend.competition_department', null),
                school_competitions: _.get(info, 'school_extend.school_competitions', null),
                participants_per_year: _.get(info, 'school_extend.participants_per_year', null),
                offering_courses: _.get(info, 'school_extend.offering_courses', null),
                tags: []
            };
        },
        update () {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.$normalRequest('school/updateSchool', {
                    id: this.currentManagedSchoolId,
                    region_id: this.schoolInfo.region_id,
                    subject_id: this.schoolInfo.subject_id,
                    detail: this.schoolInfo.detail,

                    laboratory_area: parseFloat(this.schoolInfo.laboratory_area),
                    competition_department: this.schoolInfo.competition_department,
                    school_competitions: this.schoolInfo.school_competitions,
                    participants_per_year: parseInt(this.schoolInfo.participants_per_year),
                    offering_courses: this.schoolInfo.offering_courses,
                }, '更新成功', true, this, 'requesting').then(_ => {
                    this.$refs.form.clearValidate();
                    this.reloadManagedSchoolInfo();
                }).catch(_ => {
                });
            });
        },
        reset () {
            this.schoolInfo = this.extract(this.currentManagedSchoolInfo);
            this.$refs.form.clearValidate();
        },
        reloadManagedSchoolInfo () {
            this.$store.dispatch('school/loadManagedSchoolInfo').then();
        }
    }
};
</script>
